import { Application } from "@hotwired/stimulus"

declare global {
    interface Window {
        Stimulus: Application;
    }
}

const application: Application = Application.start()

application.debug = true
window.Stimulus = application

export { application }
